import Cookies from 'js-cookie'

import { PROMO_CODE_DEFAULT_VALUE } from 'artkive/stores/ecom/stores/promo.store'

export const COOKIE_KEYS = {
  KLAVIYO_EMAIL_FORM_SUBMITTED: 'klaviyoEmailFormSubmitted',
  KLAVIYO_PHONE_NUMBER_FORM_SUBMITTED: 'klaviyoPhoneNumberFormSubmitted',
  KLAVIYO_PROMO_CODE: 'klaviyoPromoCode',
}

export const KLAVIYO_FORM_TYPES = {
  EMBED: 'embed',
  POPUP: 'popup',
}

const SUBMITTED_FORM_TYPES = [KLAVIYO_FORM_TYPES.POPUP, KLAVIYO_FORM_TYPES.EMBED]

export const getKlaviyoArtkiveProperties = () => {
  if (typeof window !== 'undefined' && window.app.klaviyo) {
    return window.app.klaviyo
  }
}

export const klaviyoFormClass = 'klaviyo-form'

const getFormType = (formId) => {
  const klaviyoEmbedFormIds = [
    getKlaviyoArtkiveProperties()?.klaviyoEmbedEmailFormId,
    getKlaviyoArtkiveProperties()?.klaviyoEmbedPhoneFormId,
  ]
  const isEmbedForm = klaviyoEmbedFormIds.includes(formId)
  return isEmbedForm ? KLAVIYO_FORM_TYPES.EMBED : KLAVIYO_FORM_TYPES.POPUP
}

export const getEmbedFormIdToDisplay = () => {
  const isEmailFormSubmitted = Cookies.get(COOKIE_KEYS.KLAVIYO_EMAIL_FORM_SUBMITTED)
  const isPhoneNumberFormSubmitted = Cookies.get(COOKIE_KEYS.KLAVIYO_PHONE_NUMBER_FORM_SUBMITTED)
  const embedEmailFormId = getKlaviyoArtkiveProperties()?.klaviyoEmbedEmailFormId
  const embedPhoneFormId = getKlaviyoArtkiveProperties()?.klaviyoEmbedPhoneFormId

  if (SUBMITTED_FORM_TYPES.includes(isPhoneNumberFormSubmitted)) return ''
  if (SUBMITTED_FORM_TYPES.includes(isEmailFormSubmitted)) return embedPhoneFormId
  return embedEmailFormId
}

export const onKlaviyoForms = async (e) => {
  if (e.detail.type !== 'stepSubmit') return

  const formId = e.detail.formId
  const formType = getFormType(formId)
  const formVersionId = e.detail.formVersionId

  const email = e.detail.metaData?.$email || e.detail.metaData?.sentIdentifiers?.$email
  const firstName = e.detail.metaData?.$first_name
  const phoneNumber = e.detail.metaData?.$phone_number

  if (email || phoneNumber) {
    window.customIdentify({ email, firstName, phone: phoneNumber })
  } // TODO: does it make sense to send a sentry issue for else clause and return

  const emailStepName = getKlaviyoArtkiveProperties()?.klaviyoStepName?.email
  const smsStepName = getKlaviyoArtkiveProperties()?.klaviyoStepName?.sms
  const isEmailStep = e.detail.metaData?.$step_name?.toLowerCase() === emailStepName?.toLowerCase()
  const isSmsStep = e.detail.metaData?.$step_name?.toLowerCase() === smsStepName?.toLowerCase()
  const stepName = isEmailStep
    ? 'email'
    : isSmsStep
      ? 'sms'
      : undefined

  const promoForPhoneNumber = getKlaviyoArtkiveProperties()?.promoForPhoneNumber
  const formVersionIdToPromoCodeMap = getKlaviyoArtkiveProperties()?.formVersionIdToPromoCodeMap

  const promoCode =
    formVersionIdToPromoCodeMap?.[formVersionId]?.[stepName]
    || (isEmailStep ? PROMO_CODE_DEFAULT_VALUE : isSmsStep ? promoForPhoneNumber : undefined)

  const expires = getKlaviyoArtkiveProperties()?.klaviyoFormResetInDays

  Cookies.set(COOKIE_KEYS.KLAVIYO_PROMO_CODE, promoCode, { expires })

  if (isEmailStep) {
    Cookies.set(COOKIE_KEYS.KLAVIYO_EMAIL_FORM_SUBMITTED, formType, { expires })
  }
  if (isSmsStep) {
    Cookies.set(COOKIE_KEYS.KLAVIYO_PHONE_NUMBER_FORM_SUBMITTED, formType, { expires })
  }

  return {
    formId,
    formType,
    promoCode,
    step: stepName,
    firstName,
    email,
    phoneNumber,
  }
}
